import styled from '@emotion/styled';
import { BREAKPOINTS, mediaQuery } from '@presentation/styles';

export const TopWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 30px;

  ${mediaQuery(BREAKPOINTS.medium)} {
    flex-direction: column;
    gap: 16px;
  }
`;

export const TopWrapperColumn = styled.div<{ width: number }>`
  ${mediaQuery(BREAKPOINTS.medium, 'min')} {
    width: ${(props) => `${props.width}%`};
  }
`;

export const Text = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
`;

export const SubText = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  margin-top: 16px;
`;

export const ProgressBarHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ProgressBarTitle = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
`;

export const ProgressBarValue = styled.div<{ full: boolean }>`
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: ${(props) => props.theme.color.blue.default}
  white-space: nowrap;
`;

export const ProgressBarWrapper = styled.div`
  margin-top: 32px;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${(props) => props.theme.color.light.shadeLighter};
  position: absolute;
  left: 0;
  margin-top: 40px;
`;

export const CardsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  margin-top: 80px; // Hack because divider is absolute, visually will look 40

  > * {
    flex: 1;
  }

  ${mediaQuery(BREAKPOINTS.phone)} {
    flex-direction: column;
  }
`;
export const CardItemWrapper = styled.div`
  height: 300px;
  padding: 15px;
  width: 25%;
  min-width: 250px;
  ${mediaQuery('desktop')} {
    width: ${(1 / 3) * 100}%;
  }
  ${mediaQuery('medium')} {
    width: 50%;
  }

  ${mediaQuery('phone')} {
    min-width: auto;
    width: 100%;
  }
`;
